import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const ReviewRefinePage = lazy(
  () => import('~/features/content-enrichment/pages/review-refine-page'),
);

export const Route = createFileRoute(
  '/_authenticated/_tenant/experiments_/$expId/content-enrichment/review',
)({
  component: () => (
    <Suspense fallback={<PageSkeleton />}>
      <ReviewRefinePage />
    </Suspense>
  ),
});
